'use strict';
const SignalBase = require('./SignalBase.js');

const assert = require('assert');

function toChunks(str, size) {
	const chunks = [];
	for (let i = 0; i < str.length; i += size) {
		chunks.push(str.substring(i, i + size));
	}
	return chunks;
}

function calculateCarrier(n) {
	return Math.round(1000000 / calculateUnit(n));
}

function calculateUnit(n) {
	return (n * 0.241246);
}

function parsePronto(prontohex) {
	assert.ok(typeof prontohex === 'string', 'Prontohex should be string');
	assert.ok(
		/^([0-9a-f]{4}\s?){4,}$/i.test(prontohex),
		'Prontohex does not match prontohex formatting (blocks of 4 hex characters, 0-f)'
	);

	// Convert the prontohex string to decimal number chunks
	const chunks = toChunks(prontohex.replace(/\s/g, ''), 4).map(chunk => parseInt(chunk, 16));
	if (chunks[1] <= 0) throw new Error('Cannot compute carrier of 0');

	const unit = calculateUnit(chunks[1]);

	// Read sequences
	const mainSequenceLength = chunks[2] * 2;
	const repeatSequenceLength = chunks[3] * 2;
	const mainSequence = chunks.slice(4, 4 + mainSequenceLength).map(a => Math.round(a * unit));
	const repeatSequence = chunks.slice(4 + mainSequenceLength, 4 + mainSequenceLength + repeatSequenceLength).map(a => Math.round(a * unit));
	
	// Separate the intervals from the sequences to fit the format of a 'signal'.
	// They are not always used.
	const mainSequenceInterval = mainSequence.pop();
	const repeatSequenceInterval = repeatSequence.pop();
	let interval = 0;
	// only set an interval if we have a repeatsequence
	if (repeatSequence.length > 0) {
		interval = Math.max(mainSequenceInterval || 0, repeatSequenceInterval || 0);
	}

	// Return formatted prontohex
	return {
		carrier: calculateCarrier(chunks[1]),
		mainSequence,
		interval,
		repeatSequence,
	};
}

class ProntoSignal extends SignalBase {
	constructor(opts) {
		super(opts);
		this._cmds = {};
		for(let id in opts.cmds) {
			this._cmds[id] = parsePronto(opts.cmds[id]);
		}
		if(opts.toggleCmds) {
			this._toggleState = false;
			this._toggleCmds = {};
			for(let id in opts.toggleCmds) {
				this._toggleCmds[id] = parsePronto(opts.toggleCmds[id]);
			}
		}
	}

	/*
		Find the command belonging to the id,
		transmit the event 'tx' with the payload that needs to be send.
	*/
	cmd(id, repetitions) {
		let cmd = this._cmds[id];
		if( !cmd ) throw new Error('invalid_cmd');
		if(this._toggleCmds && this._toggleCmds[id]) {
			if(this._toggleState) {
				cmd = this._toggleCmds[id];
			}
			this._toggleState = !this._toggleState;
		}
		let extOpts = Object.assign({carrier: cmd.carrier}, this._opts);
		if(cmd.mainSequence.length > 0) {
			this.txRaw(cmd.mainSequence, 1, Object.assign(extOpts, {interval: cmd.interval}));
		}
		process.nextTick(()=>{
			if(cmd.repeatSequence.length > 0) {
				this.txRaw(cmd.repeatSequence, repetitions, Object.assign(extOpts, {interval: cmd.interval}));
			}
		});
	}

	/*
	This method is fairly similar to cmd()
	But it doesn't use event emitters, it simply returns signal definitions
	for both the repeatsequence and mainsequence.
	*/
	getSequencePayloads(id, repetitions) {
		let cmd = this._cmds[id];
		if( !cmd ) throw new Error('invalid_cmd');
		if(this._toggleCmds && this._toggleCmds[id]) {
			if(this._toggleState) {
				cmd = this._toggleCmds[id];
			}
			this._toggleState = !this._toggleState;
		}

		const signals = {};

    // The mainsequence must be run once
    if (cmd.mainSequence.length > 0) {
      signals.mainSequenceSignal = {
        carrier: cmd.carrier,
        interval: cmd.interval,
        data: cmd.mainSequence,
        repetitions: 1,
      };
    }

    // The repeatsequence is repeated as often as defined in 'repetitions'.
    if (cmd.repeatSequence.length > 0) {
      signals.repeatSequenceSignal = {
        carrier: cmd.carrier,
        interval: cmd.interval,
        data: cmd.repeatSequence,
        repetitions,
      };
    }

    return signals;
	}

}

module.exports = ProntoSignal;